import React, { useState } from 'react'
import Header from '../../common/Header'
import Footer from '../../common/Footer'
import { Link } from 'react-router-dom'
import ResponsivePagination from 'react-responsive-pagination';
import Oval from '../Loader/CircleLoade';
import longarrow from '../../../assets/img/longarrow.svg'
import * as Constants from "../../../Constants/index"
import axios from 'axios'
import swal from 'sweetalert'
import DatePicker from "react-datepicker";
import moment from 'moment';
import { saveAs } from 'file-saver';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

export default function TicketRaiseReport() {
    const navigate = useNavigate()
    const token = localStorage.getItem('token');
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null)
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [limit] = useState(10)
    const [filterData, setFilterData] = useState({})
    const userType = localStorage.getItem('user_type');



    const searchFormik = useFormik({
        initialValues: {
            mobile: '',
            startDate: '',
            endDate: '',
            status: ''
        },
        validate: (data) => {
            let errors = {}
            if (data.mobile) {
                if (data.mobile.length < 10) {
                    errors.mobile = 'Phone number must be in 10 digits.'
                }
            }
            if (data.startDate === '' && data.endDate !== '') {
                errors.startDate = 'Please select date'
            }
            if (data.startDate !== '' && data.endDate === '') {
                errors.endDate = 'Please select date'
            }
            if (data.startDate && data.endDate && data.startDate > data.endDate) {
                errors.endDate = 'Please select date'
            }
            if (data.startDate && data.endDate && data.startDate > data.endDate) {
                errors.endDate = 'End date should be greater than start date'
            }
            // if (data.startDate && data.endDate) {
            //     const maxEndDate = new Date(data.startDate)
            //     maxEndDate.setDate(maxEndDate.getDate() + 30) // Adjust the range as needed (e.g., 31 days)

            //     if (data.endDate > maxEndDate) {
            //         errors.endDate = 'End date should be within 31 days from the start date.'
            //     }
            // }
            return errors
        },
        onSubmit: (data) => {
            setCurrentPage(1)
            getReportData(data, 1)
            setFilterData(data)
        },
    })
    const isSearchFormFieldValid = (name) => !!(searchFormik.touched[name] && searchFormik.errors[name])
    const getSearchFormErrorMessage = (name) => {
        return isSearchFormFieldValid(name) && <small className="report-error-field">{searchFormik.errors[name]}</small>
    }

    const getReportData = async (data, pageNum) => {
        setLoading(true);
        if (!token) {
            navigate('/')
        } else {
            const searchUser = data.mobile === '' ? '' : `mobile=${data.mobile}&`
            const searchStatus = data.status === '' ? '' : `status=${data.status}&`
            let stDate
            let endDate

            var momentObj1 = moment(data.startDate)
            var momentObj2 = moment(data.endDate)
            if (data.startDate && data.endDate) {
                var startFormattedDate = momentObj1.format('YYYY-MM-DD HH:mm:ss')
                var startFormattedDate4 = momentObj2.format('YYYY-MM-DD 23:59:59')
                stDate = `start=${startFormattedDate}`
                endDate = `&end=${startFormattedDate4}&`
            } else {
                stDate = ''
                endDate = ''
            }
            await axios.get(Constants.baseUrl + `reports/raiseTicket/list?${searchUser}${searchStatus}${stDate}${endDate}sortBy=createdDateTime&sortAsc=false&limit=${limit}&page=${pageNum}`, {
                headers: {
                    Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("langauge"),
                    appVersion: Constants.av,
                    platform: Constants.pt,
                    company: Constants.company,
                    program: Constants.program,
                }
            }).then((res) => {
                const dt = res.data
                if (dt.result === 'success') {
                    setReportData(dt?.output?.results)
                    setTotalPages(dt?.output?.totalPages)
                    setLoading(false)
                } if (dt.result === 'error' || dt.result === 'dialog') {
                    setReportData(null)
                    setTotalPages(0)
                    setLoading(false)
                }
            }).catch((err) => {
                setLoading(false)
            })
        }
    }

    const download = (data) => {
        setLoading(true)
        try {
            const searchUser = data.mobile === '' ? '' : `mobile=${data.mobile}`
            const searchStatus = data.status === '' ? '' : `status=${data.status}`
            let stDate
            let endDate

            var momentObj1 = moment(data.startDate)
            var momentObj2 = moment(data.endDate)
            if (data.startDate && data.endDate) {
                var startFormattedDate = momentObj1.format('YYYY-MM-DD HH:mm:ss')
                var startFormattedDate4 = momentObj2.format('YYYY-MM-DD 23:59:59')
                stDate = `start=${startFormattedDate}`
                endDate = `&end=${startFormattedDate4}&`
            } else {
                stDate = ''
                endDate = ''
            }
            let endpoint
            if (data.mobile !== '' && data.status === '' && data.startDate === '' && data.endDate === '') {
                endpoint = `reports/download/raiseTicket?${searchUser}`
            }
            if (data.mobile === '' && data.status !== '' && data.startDate === '' && data.endDate === '') {
                endpoint = `reports/download/raiseTicket?${searchStatus}`
            }
            if (data.mobile === '' && data.status === '' && data.startDate !== '' && data.endDate !== '') {
                endpoint = `reports/download/raiseTicket?${stDate}${endDate}`
            }
            if (data.mobile !== '' && data.status !== '' && data.startDate === '' && data.endDate === '') {
                endpoint = `reports/download/raiseTicket?${searchUser}&${searchStatus}`
            }
            if (data.mobile !== '' && data.status === '' && data.startDate !== '' && data.endDate !== '') {
                endpoint = `reports/download/raiseTicket?${searchUser}&${stDate}${endDate}`
            }
            if (data.mobile === '' && data.status !== '' && data.startDate !== '' && data.endDate !== '') {
                endpoint = `reports/download/raiseTicket?${searchStatus}&${stDate}${endDate}`
            }
            if (data.mobile !== '' && data.status !== '' && data.startDate !== '' && data.endDate !== '') {
                endpoint = `reports/download/raiseTicket?${searchUser}&${searchStatus}&${stDate}${endDate}`
            }
            axios.get(Constants.baseUrl + `${endpoint}`, {
                headers: {
                    Authorization: `Bearer ${token}`, "Accept-Language": localStorage.getItem("langauge"),
                    appVersion: Constants.av,
                    platform: Constants.pt,
                    company: Constants.company,
                    program: Constants.program,
                },
                responseType: 'blob', // Set the responseType to 'blob'
            }).then((res) => {
                if (res.status === 200) {
                    setLoading(false)
                    const fileData = new Blob([res.data], { type: 'text/csv' });
                    saveAs(fileData, 'ticketRaiseReport.csv');
                } else {
                    swal({
                        text: res.data.msg,
                        // icon: 'error',
                        timer: 2000,
                        buttons: false,
                    })
                }
            })
        } catch (error) {
            console.log(error)
        }
    }
    const areAllValuesBlank = () => {
        const { mobile, startDate, endDate, status } = searchFormik.values
        return (
            !mobile && !startDate && !endDate && !status
        )
    }





    return (
        <>
            {loading ? <Oval /> : null}
            <Header />
            <section className="blog-area pt182">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 tab mb-20">
                            <ul className="nav nav-tabs" role="tablist">
                                <li role="presentation" className="active"><Link to="" role="tab" data-toggle="tab">Ticket Raise Report</Link></li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="all-single-blog rpt">
                                <form onSubmit={searchFormik.handleSubmit}>
                                    <div className="row clearfix mb-15 callwell">
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                            <input
                                                id="mobile"
                                                value={searchFormik.values.mobile}
                                                onChange={e => {
                                                    // Allow only numeric input
                                                    const numericValue = e.target.value.replace(/\D/g, '');
                                                    searchFormik.handleChange({
                                                        target: {
                                                            name: 'mobile',
                                                            value: numericValue,
                                                        },
                                                    });
                                                }}
                                                type="text"
                                                className="frmcntrl"
                                                placeholder="Mobile Number"
                                                maxLength='10'
                                            />
                                            {getSearchFormErrorMessage('mobile')}
                                        </div>
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                            <DatePicker
                                                id="startDate"
                                                selected={searchFormik.values.startDate}
                                                onChange={(date) => searchFormik.setFieldValue('startDate', date)}
                                                dateFormat="dd-MM-yyyy"
                                                className="frmcntrl"
                                                showYearDropdown
                                                showMonthDropdown
                                                autoComplete="off"
                                                scrollableYearDropdown
                                                maxDate={new Date()}
                                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input using keyboard
                                                onFocus={(e) => e.target.blur()} // Blur the input to prevent focus
                                                onClick={(e) => e.preventDefault()} // Preven
                                                placeholderText='From date'
                                            />
                                            {getSearchFormErrorMessage('startDate')}
                                        </div>
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                            <DatePicker
                                                id="endDate"
                                                selected={searchFormik.values.endDate}
                                                onChange={(date) => searchFormik.setFieldValue('endDate', date)}
                                                dateFormat="dd-MM-yyyy"
                                                className="frmcntrl"
                                                showYearDropdown
                                                showMonthDropdown
                                                autoComplete="off"
                                                scrollableYearDropdown
                                                maxDate={new Date()}
                                                onKeyDown={(e) => e.preventDefault()} // Prevent manual input using keyboard
                                                onFocus={(e) => e.target.blur()} // Blur the input to prevent focus
                                                onClick={(e) => e.preventDefault()} // Preven
                                                placeholderText='To date'
                                            />
                                            {getSearchFormErrorMessage('endDate')}
                                        </div>
                                        <div className="col-md-3 col-sm-12 col-xs-12">
                                            <select className="frmcntrl" id='status' value={searchFormik.values.status} onChange={searchFormik.handleChange}>
                                                <option value="">Select Status</option>
                                                <option value="OPEN">Open</option>
                                                <option value="CLOSED">Closed</option>
                                            </select>
                                        </div>
                                        <div className="col-md-12 col-sm-12 col-xs-12 " style={{ textAlign: 'center', marginTop: '20px' }}>
                                            <button class="btn login_white_btn" style={{ width: '25%' }} type="submit" disabled={areAllValuesBlank()}> Search <img src={longarrow} alt='' /></button>
                                        </div>
                                    </div>
                                </form>
                                <div className="row">
                                    <div className="col-md-12">
                                        {reportData === null || userType === 'RETAILER' || userType === 'SALES' ? '' :
                                            <Link class="btn login_btn fa fa-file-excel-o pull-right mt-10 mb-10" to="#" onClick={() => download(searchFormik.values)}> Export</Link>}
                                        <div className="carrd1">
                                            <div className="card-body table-responsive">
                                                <table className="table table-bordered mytable mb_01">
                                                    <thead>
                                                        <tr>
                                                            <th>S.No</th>
                                                            {/* <th>Zone</th> */}
                                                            <th>ZSM Name</th>
                                                            <th>ZSM Mobile No.</th>
                                                            {/* <th>Zone State</th> */}
                                                            {/* <th>Zone Area Name</th> */}
                                                            <th>RSM Name</th>
                                                            <th>RSM Mobile Number</th>
                                                            <th>ASM Name</th>
                                                            <th>ASM Mobile Number</th>
                                                            <th>TSE Name</th>
                                                            <th>TSE Mobile Number</th>
                                                            {userType === 'HO' ? <th>State</th> : ''}
                                                            {userType === 'HO' ? <th>District</th> : ''}
                                                            {userType === 'HO' ? <th>City</th> : ''}
                                                            {userType === 'HO' ? <th>Pin Code</th> : ''}
                                                            {userType === 'HO' ? <th>Ticket Number</th> : ''}
                                                            {userType === 'HO' ? <th>Ticket Type</th> : ''}
                                                            {userType === 'HO' ? <th>Ticket Current Status</th> : ''}
                                                            {userType === 'HO' ? <th>Created Date</th> : ''}
                                                            {userType === 'HO' ? <th>Close Date</th> : ''}
                                                            {userType === 'HO' ? <th>Description</th> : ''}
                                                            {userType === 'HO' ? <th>Raised By Name</th> : ''}
                                                            {userType === 'HO' ? <th>Raised By Contact Number</th> : ''}
                                                            {userType === 'HO' ? <th>User Type</th> : ''}
                                                            {/* {userType === 'HO' ? <th>Call Center Team</th> : ''}
                                                            {userType === 'HO' ? <th>Last Update Data</th> : ''}
                                                            {userType === 'HO' ? <th>Source of Ticket - Self/Call center etc</th> : ''} */}
                                                            {userType === 'RETAILER' ? <th>Plumber Name</th> : ''}
                                                            {userType === 'RETAILER' ? <th>Plumber Mobile No.</th> : ''}
                                                            {userType === 'RETAILER' ? <th>Plumber City</th> : ''}
                                                            {userType === 'RETAILER' ? <th>Plumber Concern ID</th> : ''}
                                                            {userType === 'RETAILER' ? <th>Date of Concern </th> : ''}
                                                            {userType === 'RETAILER' ? <th>Concern Request To</th> : ''}
                                                            {userType === 'RETAILER' ? <th>Request of Concern</th> : ''}
                                                            {userType === 'RETAILER' ? <th>status</th> : ''}
                                                        </tr>
                                                    </thead>
                                                    {reportData === null ?
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="13" style={{ textAlign: 'center', fontSize: '16px' }}>No record found!</td>
                                                            </tr>
                                                        </tbody> :
                                                        <tbody>
                                                            {reportData && reportData.map((item, index) => {
                                                                const serialNumber = (currentPage - 1) * limit + index + 1;
                                                                const createDate = item[15] ? moment(item[15]).format('DD-MM-YYYY') : '';
                                                                const colseDate = item[16] ? moment(item[16]).format('DD-MM-YYYY') : '';
                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <td>{serialNumber}</td>
                                                                            {/* <td></td> */}
                                                                            <td>{item[18]}</td>
                                                                            <td>{item[19]}</td>
                                                                            {/* <td></td> */}
                                                                            {/* <td></td> */}
                                                                            <td>{item[0]}</td>
                                                                            <td>{item[1]}</td>
                                                                            <td>{item[2]}</td>
                                                                            <td>{item[3]}</td>
                                                                            <td>{item[4]}</td>
                                                                            <td>{item[5]}</td>
                                                                            {userType === 'HO' ? <td>{item[8]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[9]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[10]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[11]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[12]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[13]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[14]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{createDate}</td> : ''}
                                                                            {userType === 'HO' ? <td>{colseDate}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[17]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[6]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[7]}</td> : ''}
                                                                            {userType === 'HO' ? <td>{item[20]}</td> : ''}
                                                                            {/* {userType === 'HO' ? <td></td> : ''}
                                                                            {userType === 'HO' ? <td></td> : ''}
                                                                            {userType === 'HO' ? <td></td> : ''} */}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                            {userType === 'RETAILER' ? <td></td> : ''}
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })}

                                                        </tbody>}
                                                </table>
                                                {totalPages > 1 && (
                                                    <ResponsivePagination
                                                        current={currentPage}
                                                        total={totalPages}
                                                        onPageChange={(page) => {
                                                            setCurrentPage(page);
                                                            getReportData(filterData, page)
                                                        }} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>
                    </div>
                </div>

            </section>
            <Footer />
        </>)
}
